module.exports = __webpack_public_path__ + "static/media/blink.d88d630d.mp4";